(function () {
  if (window.LioneloPriceCopy && window.LioneloPriceCopy.initialized) return;

  window.LioneloPriceCopy = {
    initialized: true,
    timeout: null,
    fallbackCopy: function (text) {
      var input = document.createElement('textarea');
      input.value = text;
      input.setAttribute('readonly', '');
      input.style.position = 'fixed';
      input.style.opacity = '0';
      document.body.appendChild(input);
      input.select();
      document.execCommand('copy');
      input.remove();
    },
    showToast: function (label) {
      var toast = document.querySelector('[data-product-price-copy-toast]');

      if (!toast) {
        toast = document.createElement('div');
        toast.className = 'product-price-copy-toast';
        toast.setAttribute('data-product-price-copy-toast', '');
        toast.setAttribute('role', 'status');
        toast.setAttribute('aria-live', 'polite');
        toast.innerHTML = '<span class="product-price-copy-toast__icon" aria-hidden="true"><svg width="100%" height="100%" viewBox="0 0 25 25" xmlns="http://www.w3.org/2000/svg"><path d="M20.3232 6.71851L9.32324 17.7185L4.32324 12.7185" fill="none" stroke="currentColor" stroke-width="5" stroke-linecap="square" stroke-linejoin="round"/></svg></span><span class="product-price-copy-toast__text"></span>';
        document.body.appendChild(toast);
      }

      toast.querySelector('.product-price-copy-toast__text').textContent = label;
      toast.classList.add('is-visible');
      clearTimeout(this.timeout);
      this.timeout = setTimeout(function () {
        toast.classList.remove('is-visible');
      }, 3000);
    },
    copy: function (button) {
      var code = button.dataset.code;
      var label = button.dataset.toastLabel;
      var write = navigator.clipboard && navigator.clipboard.writeText
        ? navigator.clipboard.writeText(code)
        : Promise.resolve(this.fallbackCopy(code));

      write.then(function () {
        button.classList.add('is-copied');
        window.LioneloPriceCopy.showToast(label);
        setTimeout(function () {
          button.classList.remove('is-copied');
        }, 3000);
      });
    }
  };

  document.addEventListener('click', function (event) {
    var button = event.target.closest('[data-product-price-copy]');
    if (!button) return;

    event.preventDefault();
    window.LioneloPriceCopy.copy(button);
  });
})();
